"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Description;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["style"];
function Description(props) {
  var style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: [styles.description, style]
  }, rest));
}
Description.propTypes = _Text["default"].propTypes;
Description.defaultProps = Description.defaultProps || {};
Description.defaultProps.allowFontScaling = false;
var styles = _reactNative.StyleSheet.create({
  description: {
    fontSize: 16,
    lineHeight: 24
  }
});